import React from 'react'
import axios from 'axios'
import { useState,useEffect } from 'react'
import './App.css'


function Latest() {
  const [state,setstate]=useState([])
  const[loading,setloading]=useState(false)
  useEffect(()=>{
    setloading(true)
    axios.get('https://finnewsapi.onrender.com/').then((res)=>{
      setstate(res.data)

      
      
    }).finally(()=>{
      setloading(false)
    })

  },[])




  
 
  return (
    <div>

      <h2>Latest news</h2>
     
      {loading && <p>Loading news… ⏳</p>}

      {state.map((item)=>{
        
        return(
          <div>
            <h3>{item.title}</h3>
            <span>{item.summary}</span>
            <a href={item.url} target='_blank'>
              <button className='more'>More</button>
            </a>
            <hr />
          </div>
        
        )
      })}
    </div>
  )
}

export default Latest
